import React, { useEffect, useState } from "react";
import "../Style/ProductsManager.css"
import API from "../api";
import { COURSE_PLAN_LABEL, getCoursePlan, isSafeHttpUrl } from "../utilities/coursePlan";
import CoursePlanLink from "./CoursePlanLink";

const ProductsManager = () => {
    const [products, setProducts] = useState([]);
    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [coursePlan, setCoursePlan] = useState("");
    const [editingProductId, setEditingProductId] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await API.get(`/products`);
                setProducts(response.data);
            } catch (err) {
                console.error("Error fetching products:", err);
                setProducts([]);
            }
        };

        fetchProducts();
    }, []);

    const handleAddOrEditProduct = async (e) => {
        e.preventDefault();
        setError("");

        if (!name.trim() || price === "") {
            setError("Լրացրեք բոլոր դաշտերը։");
            return;
        }

        const trimmedCoursePlan = coursePlan.trim();
        if (trimmedCoursePlan && !isSafeHttpUrl(trimmedCoursePlan)) {
            setError("Դասընթացի պլանի հղումը պետք է սկսվի http:// կամ https://-ով։");
            return;
        }

        const productData = {
            name: name.trim(),
            price: parseFloat(price),
            course_plan: trimmedCoursePlan || null,
        };

        try {
            let response;

            if (editingProductId) {
                response = await API.put(`/products/${editingProductId}`, productData);
            } else {
                response = await API.post("/products", productData);
            }

            const updatedProduct = response.data;

            setProducts((prevProducts) =>
                editingProductId
                    ? prevProducts.map((product) =>
                        product.id === editingProductId ? updatedProduct : product
                    )
                    : [...prevProducts, updatedProduct]
            );

            resetForm();
        } catch (err) {
            console.error("Error saving product:", err);
            setError(err.response?.data?.message || "Չհաջողվեց պահպանել ապրանքը։");
        }
    };

    const handleDeleteProduct = async (id) => {
        try {
            await API.delete(`/products/${id}`);
            setProducts((prevProducts) => prevProducts.filter((product) => product.id !== id));
        } catch (err) {
            console.error("Սխալ delete-ի ընթացքում:", err);
            alert("Չհաջողվեց ջնջել ապրանքը։");
        }
    };

    // FIX: previously this read product.name_en / product.name_hy, but the
    // product list endpoint only ever returned a single `name` field — so
    // clicking "Edit" silently set both name inputs to undefined, and
    // saving would overwrite the product's name with an empty string. The
    // product model is now single-language (`name`), matching what the
    // list endpoint actually returns.
    const handleEditProduct = (product) => {
        setEditingProductId(product.id);
        setName(product.name);
        setPrice(product.price);
        setCoursePlan(getCoursePlan(product));
    };

    const resetForm = () => {
        setEditingProductId(null);
        setName("");
        setPrice("");
        setCoursePlan("");
        setError("");
    };

    return (
        <div className="products-manager-container">
            <h2>Ապրանքների կառավարում</h2>
            <form className="products-manager-form" onSubmit={handleAddOrEditProduct}>
                <label className="products-manager-label">Անուն</label>
                <input
                    className="products-manager-input"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Դասընթացի անվանումը"
                />
                <label className="products-manager-label">Գին</label>
                <input
                    className="products-manager-input"
                    type="number"
                    min="0"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    placeholder="Գին"
                />
                <label className="products-manager-label">{COURSE_PLAN_LABEL} (հղում)</label>
                <input
                    className="products-manager-input"
                    type="url"
                    maxLength={500}
                    value={coursePlan}
                    onChange={(e) => setCoursePlan(e.target.value)}
                    placeholder="https://..."
                />
                {error && <p className="error-text">{error}</p>}
                <button className="products-manager-button" type="submit">
                    {editingProductId ? "Թարմացնել" : "Ավելացնել"}
                </button>
                {editingProductId && (
                    <button className="products-manager-button" type="button" onClick={resetForm}>
                        Չեղարկել
                    </button>
                )}
            </form>
            <ul className="products-manager-list">
                {products.map((product) => (
                    <li className="products-manager-item" key={product.id}>
                        <strong className="products-manager-strong">{product.name}</strong> - {product.price} դրամ
                        {isSafeHttpUrl(getCoursePlan(product)) && (
                            <>
                                {" "}-{" "}
                                <CoursePlanLink href={getCoursePlan(product)} />
                            </>
                        )}
                        <div>
                            <button
                                className="products-manager-button"
                                onClick={() => handleEditProduct(product)}
                            >
                                Խմբագրել
                            </button>
                            <button
                                className="products-manager-button"
                                onClick={() => handleDeleteProduct(product.id)}
                            >
                                Ջնջել
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductsManager;
